import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type FragmentMetadataTagsProps = {
  stationSlug: string;
  tags: string[];
};

/**
 * Renders fragment tags as pill chips (similar to YouTube). Each chip links to the station
 * fragments list with the `tags` URL filter set so results match that tag.
 */
export function FragmentMetadataTags({ stationSlug, tags }: FragmentMetadataTagsProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {tags.map((tag) => (
        <Link
          component={RouterLink}
          key={tag}
          to={`/fragments/s/${stationSlug}?tags=${tag}`}
          sx={{
            textDecoration: 'none',
            color: 'secondary.light',
            '&:hover': { color: 'secondary.dark' },
          }}
        >
          {`#${tag}`}
        </Link>
      ))}
    </Box>
  );
}
